var keyMirror = require('keymirror');

module.exports = keyMirror({
  WEBSOCKET_CREATE: null,
  WEBSOCKET_CLOSE: null,
  WEBSOCKET_DESTROY: null,
  WEBSOCKET_SEND: null
});



/** WEBPACK FOOTER **
 ** ./src/constants/WebsocketConstants.js
 **/